// extracted by mini-css-extract-plugin
export default {"row":"elRYTt1XWkcM7DQyV2KV"};